import { createContext } from "react";

export const rootContext = createContext(null);

// PC环境判断
export const isPC = !/iPhone|iPad|iPod|Android/ig.test(navigator.userAgent);

// FL84域名判断
export const isFl84 = window.location.host.indexOf("fl84") > -1 || window.location.href.split("#")[0].indexOf("fl84") > -1;
export const fl84RegionId = 6;

// 是否以游戏为主体
export const mainOfGame = isFl84;

// 全局通用数据
export const globalData = {
  region: "",
  XCreatorRegion: "",
  token: "",
  regionConfigId: null,
  activeGameData: {},
  baseGameList: [],
  regionGameList: [],
  activeRegion: ""
};
